import { Injectable } from '@angular/core'

import { WhiteLabelSettingsProvider } from '@ti/core/common/services'

@Injectable()
export class AdminWhiteLabelSettingsProvider extends WhiteLabelSettingsProvider {
  protected getSettings() {
    return Promise.resolve({
      name: 'TI Admin',
      domain: 'telematicsinsights.ai',
      logoLargeUrl: '',
      logoCompactUrl: '',
      logoSquareHighResUrl: '',
      googleMapsKey: '',
    })
  }
}
